import { setupLayout, moment, showLoader } from 'common.js';
import $ from 'jquery.js';
import { pluralize } from 'utils.ts';
import { apiS } from 'network/network.ts';
import 'jquery-components/bootstrap-modal';
import 'jquery-components/date-range-picker';
import 'jquery-components/number-range-picker';
import 'jquery-components/bootstrap-select';
import 'jquery-components/bootstrap-validator';

var g_validCheckInDates = {};
var g_currentTourId = null;
var g_touristPicker = null;

function setupTourSearch(searchQuery) {
    $('#countryId, #cityId, #directionId, #tourTypeId').on('change', function () {
        const countryId = $('#countryId').val();
        const cityId = $('#cityId').val();
        const directionId = $('#directionId').val();
        const tourTypeId = $('#tourTypeId').val();
        const tourId = $('#tourId').val();
        reloadSearchFilters({ countryId, cityId, directionId, tourTypeId, tourId });
    });

    $('#tourId').on('change', function () {
        var value = $(this).val();
        g_currentTourId = !value ? null : parseInt(value);
    });

    setupCheckInRangePicker();
    setupDurationPicker();
    g_touristPicker = new TouristPicker();

    if (searchQuery)
        reloadSearchFilters(searchQuery);

    $("#bookingForm").validator().on("submit", function (e) {
        if (!e.isDefaultPrevented()) {
            setTimeout(showLoader, 1000);
        }
    });
}

function setupCheckInRangePicker() {
    $('#checkInRange').daterangepicker({
        startDate: moment($('#checkInDateStart').val()),
        endDate: moment($('#checkInDateEnd').val()),
        minDate: moment(),
        autoApply: true,
        isInvalidDate: function (date) {
            // Вычеркивает даты которые не попадают в список разрешенных дат заезда.
            var s = date.format('YYYY-MM-DD');

            if (g_currentTourId === null) {
                // Если тур не выбран ищем по разрешенным датам всех туров.
                var dateSets = Object.values(g_validCheckInDates);

                for (var i = 0; i < dateSets.length; ++i) {
                    if (dateSets[i].has(s))
                        return false;
                }
            } else {
                var dateSet = g_validCheckInDates[g_currentTourId];
                if (dateSet === undefined) {
                    console.error('CheckIn date set for selected tour (' + g_currentTourId + ') is undefined');
                    return false;
                }

                return !dateSet.has(s);
            }

            return true;
        }
    });

    $('#checkInRange').on('apply.daterangepicker', function (_, picker) {
        $('#checkInDateStart').val(picker.startDate.format('YYYY-MM-DD'));
        $('#checkInDateEnd').val(picker.endDate.format('YYYY-MM-DD'));
    });
}

function setupDurationPicker() {
    function formatDuration(min, max) {
        var parts = languageStrings['TOUR_DURATION_RANGE'].split(';');
        var from = parts[0],
            to = parts[1],
            oneDay = parts[2],
            twoDays = parts[3],
            fiveDays = parts[4];
        var result = '';

        if (min != max) {
            var plural = pluralize(max, oneDay, fiveDays, fiveDays);
            result = from + ' ' + min + ' ' + to + ' ' + max + ' ' + plural;
        } else {
            var plural = pluralize(max, oneDay, twoDays, fiveDays);
            result = min.toString() + ' ' + plural;
        }

        return result.trim().replace(/\s+/g, ' ');
    }

    // Восстановить диапазон с формы, если возможно.
    var rangeMin = 1;
    var rangeMax = 28;
    var formMin = parseInt($('#durationMin').val());
    var formMax = parseInt($('#durationMax').val());
    var range =
        !isNaN(formMin) && !isNaN(formMax) && formMin <= formMax && formMin >= rangeMin && formMax <= rangeMax
            ? { min: formMin, max: formMax }
            : null;

    $('#durationRange').numberrangepicker({
        range: range,
        min: rangeMin,
        max: rangeMax,
        headerText: languageStrings['TOUR_CHOOSE_TOUR_DURATION']
    });

    if (range) {
        $('#durationRange').val(formatDuration(range.min, range.max));
        $('#durationRange').trigger('change');
    }

    // Обновление значений диапазона в hidden полях, а также текста с диапазоном
    // на форме при выборе диапазона.
    $('#durationRange').on('apply.numberrangepicker', function (e, range) {
        var min = range.min,
            max = range.max;

        $('#durationMin').val(min);
        $('#durationMax').val(max);

        $(this).val(formatDuration(min, max));

        // Запустить событие change иначе bootstrap-validator не заметит изменения.
        $(this).trigger('change');
    });
}

function TouristPicker() {
    var self = this;
    var $count = $('#nrChildren');
    var $ages = $('.child');

    self.setChildCount = function (count) {
        $ages.each(function (i) {
            if (i < count) {
                $(this).css('visibility', 'visible');
                $(this).prop('disabled', null);
            } else {
                $(this).css('visibility', 'hidden');
                $(this).prop('disabled', '');
            }
        });
    }

    self.getChildCount = function () { return parseInt($count.val()); }
    self.refreshChildCount = function () { self.setChildCount(self.getChildCount()); }

    self.init = function () {
        $count.on('change', function () {
            self.setChildCount(self.getChildCount());
        });

        self.refreshChildCount();
    }

    self.init();
}

function updateBootstrapSelect($el, value, optionList) {
    // Убрать все дочерние <option> элементы кроме <option> с пустым value. 
    $el.children().filter(function (_, x) { return !!$(x).val() }).remove();

    for (const [optionValue, text] of optionList)
        $el.append($('<option>').attr('value', optionValue).text(text));

    $el.selectpicker('refresh');
    $el.selectpicker('val', value);
}

function reloadSearchFilters(queryParams) {
    const dependencyMap = {
        'Cities': { selector: '#cityId', value: queryParams.cityId },
        'Directions': { selector: '#directionId', value: queryParams.directionId },
        'TourTypes': { selector: '#tourTypeId', value: queryParams.tourTypeId },
        'Tours': { selector: '#tourId', value: queryParams.tourId },
    };

    fetchFilterData(queryParams).then(response => {
        for (var [key, values] of Object.entries(response)) {
            const { selector, value } = dependencyMap[key];
            const $el = $(selector);

            if (!$el.length) {
                console.error('Dependency mapping error: ' + key + ' => ' + selector + ': bad selector');
                continue;
            }

            updateBootstrapSelect($el, value, values.map(({ Id, Name }) => [Id, Name]));

            g_currentTourId = $('#tourId').val() ? parseInt($('#tourId').val()) : null;
            g_validCheckInDates = {};
        }

        return response;
    }).then(response => {
        // Обновление доступных/недоступных дат заезда для вычеркивания в пикере дат.
        g_currentTourId = queryParams.tourId || null;
        g_validCheckInDates = {};

        var tours = response['Tours'];
        if (!tours || tours.length === 0)
            return;

        var result = {};
        for (let tour of tours) {
            const dateSet = new Set();
            for (var j = 0; j < tour.CheckInDates.length; ++j)
                dateSet.add(tour.CheckInDates[j]);

            result[tour.Id] = dateSet;
        }

        g_validCheckInDates = result;
        return response;
    }).then(_ => {
        var dependentElems = $('#cityId, #directionId, #tourTypeId, #tourId, #checkInRange, #durationRange');
        $(dependentElems).prop('disabled', null);
        $(dependentElems).selectpicker('refresh');
    });
}

function fetchFilterData(queryParams) {
    return apiS('get', '/Tour/NarrowSearchParamSet', queryParams).then(({ response, errors }) => {
        if (!errors)
            return response;
        throw new Error(errors);
    });
}

$(document).ready(function () {
    /* // wip: debug code for validation and country selector issue.
    document.addEventListener('click', (e) => {
        var $el = $(e.target).closest('a');
        if (!$el.length)
            return;

        if ($el.text().trim() == 'Spain')
            debugger;
    }, true);
    */
});

export {
    setupLayout,
    setupTourSearch
}